
export default class PrivacyPolicyStatusViewModel {
    constructor(data) {
        this.agreed = data.agreed;
        this.kind = data.kind;
        this.url = data.url;
        this.version = data.version;
    }
}